export default "__VITE_ASSET__Cc6QQ_b3__"